import React from "react";
import { createRoot } from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./store/store";
import PersistProvider from "./store/providers/persist-provider";
import App from "./App";

import "animate.css";
import "swiper/swiper-bundle.min.css";
import "yet-another-react-lightbox/styles.css";
import "yet-another-react-lightbox/plugins/thumbnails.css";
import "./assets/scss/style.scss";
import "./i18n";

import { Toaster } from "react-hot-toast";

const container = document.getElementById("root");
const root = createRoot(container);

root.render(
  <Provider store={store}>
    <PersistProvider>
      <App />
      <Toaster
        position="bottom-right"
        toastOptions={{
          success: { style: { background: "#4caf50", color: "white" } },
          error: { style: { background: "#f44336", color: "white" } },
        }}
      />
    </PersistProvider>
  </Provider>
);
